import { render } from "./NvarDashboard.vue?vue&type=template&id=13389a04&scoped=true"
import script from "./NvarDashboard.vue?vue&type=script&lang=js"
export * from "./NvarDashboard.vue?vue&type=script&lang=js"

import "./NvarDashboard.vue?vue&type=style&index=0&id=13389a04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13389a04"]])

export default __exports__